import React, { useMemo } from 'react';
import { CardUserFinderBuyOrderProps } from './types';
import { userName } from '@shared/lib/utils/user-name/user-name';
import { CardUserFinder } from '@entities/user/ui/card-user-request/card-user-request';
import { CreateEmployeeRequestInOrder } from '@features/request/create-employee-request-in-order/ui/create-employee-request-in-order';
import { isExistUserRequest } from '@widgets/buy-manager-order/lib/utils/is-exist-user-request/is-exist-user-request';

export const CardUserFinderBuyOrder: React.FC<CardUserFinderBuyOrderProps> = ({ user, order, onAddUser, onClick }) => {
    const isAlreadyExistRequest = useMemo(() => {
        return isExistUserRequest(order, user.id);
    }, [order, user.id]);

    return (
        <CardUserFinder
            avatarUrl={user.photoUrl}
            userName={userName(user).full}
            jobTitle={user.jobTitle}
            onClick={onClick}>
            <div onClick={(e) => e.stopPropagation()}>
                <CreateEmployeeRequestInOrder
                    user={user}
                    order={order}
                    isAlreadyExist={isAlreadyExistRequest}
                    onAddUser={onAddUser}
                />
            </div>
        </CardUserFinder>
    );
};
